@if (loading()) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
} @else {
	<app-setup-wizard-dynamic-table
		[enableEditButton]="enableEditButton()"
		[enableToggleDisableButton]="enableToggleDisableButton()"
		[enableRemoveButton]="enableRemoveButton()"
		[enableResetButton]="enableResetButton()"
		[selectedRow]="selectedRow()"
		[rows]="rows()"
		[pageSize]="pageSize()"
		[columns]="columns()"
		(onToggleDisable)="onToggleDisableClick($event)"
		(onRemove)="onRemoveClick($event)"
		(onReset)="onResetClick($event)"
		(onEdit)="onEditClick($event)"
	>
		<!-- Header templates (defines order/keys) -->
		<ng-template [appHeaderColumn]="ContentCsvKeys.ssoContentId">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.ssoContentId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.ssoActivityId">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.ssoActivityId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.defaultLangId">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.defaultLangId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.displayOrder">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.displayOrder] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.isInstruction">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.isInstruction] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.contentType">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.contentType] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.featuredMode">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.featuredMode] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.scoringMethod">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.scoringMethod] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.skillCode">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.skillCode] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.rubricLevel">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.rubricLevel] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.enName">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.enName] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.enContentUri">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.enContentUri] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.enContentTags">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.enContentTags] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ContentCsvKeys.active">
			{{ CONTENT_CSV_LABELS[ContentCsvKeys.active] }}
		</ng-template>

		<ng-template appHeaderColumn="status">Status</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template [appRowColumn]="ContentCsvKeys.ssoContentId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.ssoContentId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.ssoActivityId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.ssoActivityId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.defaultLangId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.defaultLangId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.displayOrder" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.displayOrder"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.isInstruction" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.isInstruction"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.contentType" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.contentType"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.featuredMode" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.featuredMode"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.scoringMethod" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.scoringMethod"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.skillCode" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.skillCode"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.rubricLevel" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.rubricLevel"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.enName" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="ContentCsvKeys.enName"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.enContentUri" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.enContentUri"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.enContentTags" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ContentCsvKeys.enContentTags"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ContentCsvKeys.active" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="ContentCsvKeys.active"></app-setup-wizard-before-after>
		</ng-template>

		<ng-template appRowColumn="status" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after-status [data]="row"></app-setup-wizard-before-after-status>
		</ng-template>
	</app-setup-wizard-dynamic-table>
}
